<template>
    <div class="echarts-doughnut-wrapper" :style="{ height: height + 'px' }">
        <v-chart :options="chartOptions" autoresize ref="chart" />
    </div>
</template>
<script>
export default {
    name: "EChartsDoughnut",
    props: {
        labels: { type: Array, default: () => [] },
        datasets: { type: Array, default: () => [] },
        options: { type: Object, default: () => ({}) },
        height: { type: Number, default: 300 },
        halfMode: { type: Boolean, default: false },
    },
    computed: {
        chartOptions() {
            const ds = this.datasets[0] || {};
            const seriesData = this.labels.map((label, i) => ({
                name: label,
                value: (ds.data || [])[i] || 0,
                itemStyle: Array.isArray(ds.backgroundColor)
                    ? { color: ds.backgroundColor[i] }
                    : undefined,
            }));

            const pieConfig = this.halfMode
                ? { startAngle: 180, endAngle: 360 }
                : {};

            return {
                tooltip: {
                    trigger: "item",
                    backgroundColor: "rgba(0,0,0,0.8)",
                    textStyle: { color: "#fff", fontSize: 12 },
                    padding: 12,
                    borderRadius: 8,
                    formatter: "{b}: {c} ({d}%)",
                },
                legend: {
                    orient: "horizontal",
                    bottom: this.halfMode ? 0 : "auto",
                    top: this.halfMode ? "auto" : 0,
                    textStyle: { fontSize: 12 },
                },
                series: [
                    {
                        type: "pie",
                        radius: ["40%", "70%"],
                        center: ["50%", this.halfMode ? "70%" : "55%"],
                        avoidLabelOverlap: true,
                        ...pieConfig,
                        label: {
                            show: false,
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: "bold",
                            },
                        },
                        labelLine: { show: false },
                        data: seriesData,
                    },
                ],
                ...this.options,
            };
        },
    },
};
</script>
<style scoped>
.echarts-doughnut-wrapper {
    position: relative;
    width: 100%;
}
.echarts-doughnut-wrapper .echarts {
    width: 100% !important;
    height: 100% !important;
}
</style>
